import React from "react";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { TitleBar } from "@swiggy-private/dls-web-core/dist/components/TitleBar";
import { IIconWithAction } from "@swiggy-private/dls-web-core/dist/components/TitleBar/types";
import { TopBar, StyledHeader, FlexContainer } from "./styles";
import { GIFT_PPI_CONSTANTS } from "../../constants";

interface IHeaderProps {
    title: string;
    subTitle?: string;
    onBackClick: VoidFunction;
    isGiftcardFlow?: boolean;
    showGiftPPIIcon?: boolean;
}

const Header: React.FC<IHeaderProps> = ({
    title,
    subTitle,
    onBackClick,
    isGiftcardFlow,
    showGiftPPIIcon,
}) => {
    const leftIcon: IIconWithAction = {
        iconName: "arrowBack20",
        accessibilityLabel: "back-arrow",
        onClick: onBackClick,
    };

    return (
        <StyledHeader isGiftcardFlow={isGiftcardFlow}>
            <TopBar>
                <TitleBar
                    title={title}
                    subTitle={subTitle}
                    leftIcon={leftIcon}
                    testIdPrefix="header"
                    removePadding
                    disableIconBgColor
                />
                {showGiftPPIIcon && (
                    <FlexContainer>
                        <Text color="text_Low_Emphasis" variant="V2.body3.neutral.regular">
                            {GIFT_PPI_CONSTANTS.POWERED_BY}
                        </Text>
                        <Image
                            width={`${GIFT_PPI_CONSTANTS.IMAGE.WIDTH}px`}
                            height={`${GIFT_PPI_CONSTANTS.IMAGE.HEIGHT}px`}
                            cloudinaryHeight={3 * GIFT_PPI_CONSTANTS.IMAGE.HEIGHT}
                            cloudinaryWidth={3 * GIFT_PPI_CONSTANTS.IMAGE.WIDTH}
                            alt="RazorPay"
                            cloudinaryId={GIFT_PPI_CONSTANTS.IMAGE.SRC}
                        />
                    </FlexContainer>
                )}
            </TopBar>
        </StyledHeader>
    );
};

export default React.memo(Header);
